import { render, staticRenderFns } from "./resource-shixun.vue?vue&type=template&id=0cec0b60&scoped=true&"
import script from "./resource-shixun.vue?vue&type=script&lang=ts&"
export * from "./resource-shixun.vue?vue&type=script&lang=ts&"
import style0 from "./resource-shixun.vue?vue&type=style&index=0&id=0cec0b60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cec0b60",
  null
  
)

export default component.exports